import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";

import Address from "../address";
import CustomTitle from "../../../app/generic/customTitle";
import { isBoolean } from "../../../../modules/dataFunctions";
import CheckboxItem from "../../../app/generic/form/checkboxItem";

export const invoiceAddressInputId = "Invoice",
  pickupAddressInputId = "Pickup";

export const getDefaultAddressOrSameForm = () => ({
  sameInvoiceAddress: true,
  samePickupAddress: true,
});

const AddressOrSame = ({
  form,
  pickup,
  initialAddress,
  formItemLayout,
  initialSameAddress,
}) => {
  const [hideAddress, setHideAddress] = useState(
    isBoolean(initialSameAddress) ? initialSameAddress : true
  );
  const handleCheckboxChange = useCallback((e) => {
    setHideAddress(e.target.checked);
  }, []);

  return (
    <>
      {pickup ? (
        <CustomTitle
          id="registration.address.pickup"
          defaultMessage="Svozová adresa"
        />
      ) : (
        <CustomTitle
          id="registration.address.invoice"
          defaultMessage="Fakturační adresa"
        />
      )}
      <CheckboxItem
        formItemLayout={formItemLayout}
        onChange={handleCheckboxChange}
        fieldName={pickup ? "samePickupAddress" : "sameInvoiceAddress"}
        checkboxLabel={
          <FormattedMessage
            id="registration.address.invoice.same"
            defaultMessage="stejná jako sídelní"
          />
        }
      />
      {!hideAddress && (
        <Address
          form={form}
          initialAddress={initialAddress}
          formItemLayout={formItemLayout}
          addressType={pickup ? pickupAddressInputId : invoiceAddressInputId}
        />
      )}
    </>
  );
};

export default AddressOrSame;
